import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function PrivateRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) {
    return <Navigate to="/sign-in" replace state={{ from: location }} />;
  }
  if (user.user_type !== 'root') {
    return <Navigate to="/sign-in?error=access_denied" replace state={{ from: location }} />;
  }
  return children;
}
